<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Separation Types</p>
      </div>

      <div class="flex justify-between items-center pl-0 ml-0 p-2">
        <div class="flex justify-between items-left">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="currentTableData.length"
          >
          </el-pagination>

          <!-- search -->
          <input
            v-model="searchInput"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 py-1 rounded-md"
          />
          <!-- search -->
        </div>
        <div class="flex flex-wrap justify-end w-full gap-3">
          <button
            @click="showCreateSeparationType = true"
            class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex items-center gap-1 capitalize"
          >
            <svg
              id="Layer_1"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            Create
          </button>
        </div>
      </div>

      <div class="px-2 pb-2">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocCrSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_loca }}
          </div>
        </transition>
        <div>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
          />

          <ve-table
            :columns="columns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No Separation Types found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <!-- create -->
    <CreateSeparationType
      @close="handleClose"
      :showCreateSeparationType="showCreateSeparationType"
      @closeOnSuccess="handleCloseOnSuccess"
    ></CreateSeparationType>

    <!-- edit -->
    <EditSeparationType
      @close="handleClose"
      :SeparationTypeToEdit="SeparationTypeToEdit"
      :info="SeparationTypeToEdit"
      :showEditSeparationType="showEditSeparationType"
      @closeOnSuccess="handleCloseOnSuccess"
    >
    </EditSeparationType>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
import axios from "axios";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import CreateSeparationType from "@/components/CompanySetups/separation/create.vue";
import EditSeparationType from "@/components/CompanySetups/separation/editSeparationType.vue";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import { mapGetters } from "vuex";
// import Switches from 'vue-switches';
import VeCheckbox from "vue-easytable/libs/ve-checkbox";

export default {
  name: "SeparationTypeList",
  components: {
    Loader,
    CreateSeparationType,
    EditSeparationType,
    ActionWarning,
  },
  data() {
    return {
      showCreateSeparationType: false,
      showEditSeparationType: false,
      loading: false,
      get_error: null,
      create_success: "Leave Type created successfully",
      del_loca: null,
      del_error: null,
      info: null,
      message: null,
      title: null,
      searchInput: "",
      showLocCrSuccess: false,
      showLocDelSuccess: false,
      showActions: false,
      SeparationTypeToDelete: null,
      filteredTabs: [],
      showWarning: false,
      SeparationTypeToEdit: {},
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "Name",
          title: "Name",
          headerAlign: "left",
          align: "left",
          sampleValue: "Registration",
        },
        {
          field: "Description",
          key: "Description",
          title: "Description",
          headerAlign: "center",
          align: "left",
          sampleValue: "initiated by employee",
        },
        {
          field: "AttachmentRequired",
          key: "AttachmentRequired",
          sampleValue: "true",
          title: "Attachment Required",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.AttachmentRequired}></VeCheckbox>
          ),
        },
        {
          field: "EmployeeInitiate",
          key: "EmployeeInitiate",
          sampleValue: "false",
          title: "Employee Can Initiate",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.EmployeeInitiate}></VeCheckbox>
          ),
        },
        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.currentTableData;
      } else {
        // Filter the currentTableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getSeparationTypes();
    this.setPageSizes();
  },
  methods: {
    exportTemplate() {
      this.filteredTabs = this.columns.filter(
        (column) => column.title !== "Action"
      );
      importTemplateGenerator(this.filteredTabs, "Separation Types");
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleClose() {
      this.showCreateSeparationType = false;
      this.showEditSeparationType = false;
    },
    handleCloseOnSuccess() {
      this.showCreateSeparationType = false;
      this.showLocCrSuccess = false;
      this.showEditSeparationType = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getSeparationTypes();
    },

    reload() {
      this.getDepartments();
    },
    setIsConfirmed() {
      this.showWarning = false;
      this.deleteSeparationType(this.SeparationTypeToDelete);
    },

    handleEditButtonClick(separationType) {
      // Handle the button click for the edit button
      this.SeparationTypeToEdit = separationType;
      this.showEditSeparationType = true;
    },
    handleDeleteButtonClick(SeparationType) {
      // Handle the button click for the delete button
      //console.log(SeparationType)
      this.title = `Delete ${SeparationType.Name}`;
      this.message = `You are about to delete ${SeparationType.Name}!`;
      this.SeparationTypeToDelete = SeparationType;
      this.showWarning = true;
    },

    handleDeleteOnSuccess() {
      this.showLocDelSuccess = true;
      setTimeout(() => {
        this.showLocDelSuccess = false;
      }, 3000);
      this.getSeparationTypes();
    },
    getSeparationTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/separation/type/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data.map((row) => {
                return { ...row, showActions: false };
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    deleteSeparationType(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
        data: {
          SeparationTypeId: row.SeparationTypeId,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/setup/separation/type/v1/delete/`,
          options
        )
        .then(
          (response) => {
            this.loading = false;

            if (response.data.StatusCode == 200) {
              this.handleDeleteOnSuccess();
              this.$notify({
                title: "Success",
                message: response.data.StatusMessage,
                type: "success",
              });
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
          }
        );
    },

    editSeparationType(row) {
      this.showEditSeparationType = true;
      this.info = row;
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}

.el-input.el-input--mini.el-input--suffix .el-input__inner {
  height: 30px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  margin-left: 0 !important;
}
</style>
